var _line, _line2, _path, _path2, _path3, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame48097178(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 212,
    viewBox: "0 0 335 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 94.5882,
    y2: -1,
    transform: "matrix(1 -4.37114e-08 -4.37114e-08 -1 1 7.62939e-06)",
    stroke: "#A4000A",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 25,
    y2: -1,
    transform: "matrix(0 1 1 0 2.5293 0)",
    stroke: "#A4000A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 143.172V128.279L54.8217 45H66.3572V66.9219H59.0377L21.972 126.611V127.564H93V143.172H3ZM59.8575 167V138.645L59.9746 131.854V45H77.1314V167H59.8575Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.529 167C159.371 166.961 151.546 164.552 145.055 159.773C138.563 154.993 133.598 148.035 130.159 138.9C126.72 129.764 125 118.759 125 105.884C125 93.0483 126.72 82.0818 130.159 72.9848C133.636 63.8878 138.621 56.9494 145.113 52.1697C151.643 47.3899 159.448 45 168.529 45C177.61 45 185.396 47.4092 191.887 52.2275C198.379 57.0073 203.344 63.9457 206.783 73.0427C210.261 82.1011 212 93.0483 212 105.884C212 118.797 210.28 129.822 206.841 138.957C203.402 148.054 198.437 155.012 191.945 159.83C185.454 164.61 177.648 167 168.529 167ZM168.529 151.562C176.566 151.562 182.845 147.65 187.366 139.825C191.926 132 194.206 120.686 194.206 105.884C194.206 96.055 193.163 87.7482 191.076 80.964C189.028 74.1412 186.072 68.976 182.208 65.4682C178.382 61.922 173.823 60.1488 168.529 60.1488C160.53 60.1488 154.251 64.0806 149.692 71.9441C145.132 79.8076 142.833 91.121 142.794 105.884C142.794 115.752 143.818 124.098 145.866 130.92C147.953 137.705 150.909 142.851 154.734 146.358C158.56 149.827 163.158 151.562 168.529 151.562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244 143.172V128.279L295.822 45H307.357V66.9219H300.038L262.972 126.611V127.564H334V143.172H244ZM300.858 167V138.645L300.975 131.854V45H318.131V167H300.858Z",
    fill: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 94.9999,
    y2: -1,
    transform: "matrix(-1 4.37114e-08 4.37114e-08 1 334 212)",
    stroke: "#A4000A",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 25,
    y2: -1,
    transform: "matrix(0 -1 -1 0 332.464 212)",
    stroke: "#A4000A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48097178);
export default __webpack_public_path__ + "static/media/Frame 48097178.15d39ed7e59a4966a93e02cbc79c8816.svg";
export { ForwardRef as ReactComponent };